import {
  SetLens2527bvop19mpo as SetLens,
  ModifyLens104zsbx7gwa6e as ModifyLens,
  SetValueLensuxj8ukufftbv as SetValueLens,
  ModifyValueLenspp00mwqm1elc as ModifyValueLens,
} from '../abstracts.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
import {
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  MutableValidated2ognu5vxf17ur as MutableValidated,
  lens2gvfhjoqnpofs as lens_1,
  lens2wuprihu5z787 as lens_2,
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
} from './Validated.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ValidatedSetLensClass;
function ValidatedSetLens() {
  if (ValidatedSetLensClass === VOID) {
    class $ extends SetLens() {
      constructor(source, get, set) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_ValidatedSetLens_tc311d_k$(source, get, set);
      }
      static new_com_lightningkite_reactive_lensing_validation_ValidatedSetLens_tc311d_k$(source, get, set) {
        var $this = this.new_com_lightningkite_reactive_lensing_SetLens_rp2o22_k$(source, get, set);
        $this.node_1 = new (IssueNode())(source.get_node_wor8sr_k$());
        return $this;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        this.node_1.connect_ivqcka_k$();
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        this.node_1.disconnect_t9cc0c_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'ValidatedSetLens', VOID, VOID, [MutableValidated()], [1]);
    ValidatedSetLensClass = $;
  }
  return ValidatedSetLensClass;
}
var ValidatedModifyLensClass;
function ValidatedModifyLens() {
  if (ValidatedModifyLensClass === VOID) {
    class $ extends ModifyLens() {
      constructor(source, get, modify) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_ValidatedModifyLens_n91gng_k$(source, get, modify);
      }
      static new_com_lightningkite_reactive_lensing_validation_ValidatedModifyLens_n91gng_k$(source, get, modify) {
        var $this = this.new_com_lightningkite_reactive_lensing_ModifyLens_a6lpxe_k$(source, get, modify);
        $this.node_1 = new (IssueNode())(source.get_node_wor8sr_k$());
        return $this;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        this.node_1.connect_ivqcka_k$();
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        this.node_1.disconnect_t9cc0c_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'ValidatedModifyLens', VOID, VOID, [MutableValidated()], [1]);
    ValidatedModifyLensClass = $;
  }
  return ValidatedModifyLensClass;
}
var ValidatedSetValueLensClass;
function ValidatedSetValueLens() {
  if (ValidatedSetValueLensClass === VOID) {
    class $ extends SetValueLens() {
      constructor(source, get, set) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_ValidatedSetValueLens_stsrt7_k$(source, get, set);
      }
      static new_com_lightningkite_reactive_lensing_validation_ValidatedSetValueLens_stsrt7_k$(source, get, set) {
        var $this = this.new_com_lightningkite_reactive_lensing_SetValueLens_lhprjj_k$(source, get, set);
        $this.node_1 = new (IssueNode())(source.get_node_wor8sr_k$());
        return $this;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        this.node_1.connect_ivqcka_k$();
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        this.node_1.disconnect_t9cc0c_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    initMetadataForClass($, 'ValidatedSetValueLens', VOID, VOID, [MutableValidatedValue()], [1]);
    ValidatedSetValueLensClass = $;
  }
  return ValidatedSetValueLensClass;
}
var ValidatedModifyValueLensClass;
function ValidatedModifyValueLens() {
  if (ValidatedModifyValueLensClass === VOID) {
    class $ extends ModifyValueLens() {
      constructor(source, get, modify) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_ValidatedModifyValueLens_g7yxco_k$(source, get, modify);
      }
      static new_com_lightningkite_reactive_lensing_validation_ValidatedModifyValueLens_g7yxco_k$(source, get, modify) {
        var $this = this.new_com_lightningkite_reactive_lensing_ModifyValueLens_ce3zc7_k$(source, get, modify);
        $this.node_1 = new (IssueNode())(source.get_node_wor8sr_k$());
        return $this;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        this.node_1.connect_ivqcka_k$();
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        this.node_1.disconnect_t9cc0c_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    initMetadataForClass($, 'ValidatedModifyValueLens', VOID, VOID, [MutableValidatedValue()], [1]);
    ValidatedModifyValueLensClass = $;
  }
  return ValidatedModifyValueLensClass;
}
//region block: exports
export {
  ValidatedModifyLens as ValidatedModifyLensxnr6y4izl6zn,
  ValidatedModifyValueLens as ValidatedModifyValueLensyxkqbmnu4076,
  ValidatedSetLens as ValidatedSetLens3tjmcbmmtgp0c,
  ValidatedSetValueLens as ValidatedSetValueLens1a0iz59dg9w6t,
};
//endregion

//# sourceMappingURL=validationLenses.mjs.map
